document.querySelectorAll('.tdp-article-share__copy').forEach(function (button) {
  button.addEventListener('click', function () {
    var url = button.getAttribute('data-url');
    var message = button.closest('.tdp-article-share').querySelector('.tdp-article-share__message');
    navigator.clipboard.writeText(url).then(function () {
      if (!message) return;
      message.textContent = window.accessibilityStrings ? window.accessibilityStrings.shareSuccess : '';
      message.classList.remove('visually-hidden');
    });
  });
});
